import React, {FC} from "react"
import {FeeTypeDto} from "../../types/contracts";
import {FeeTypesComponentModal} from "../admin/FeeTypesComponentModal";
import {useModal} from "../../hooks/useModal";
import {CiEdit} from "react-icons/ci";
import {MdOutlineDelete} from "react-icons/md";
import {translate} from "../../utils/functions";
import {FormField} from "../../types/enums";

interface FeeTypesComponentProps {
  feeTypes: FeeTypeDto[];
  handleFeeTypeChange: (
    index: number,
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  handleFeeCheckboxChange: (index: number, field: string) => void;
  removeFeeType: (index: number) => void;
  addFeeType: () => void;
  handleFormFieldsChange: (index: number, field: FormField) => void;
  currency?: string;
}

const FeeTypesComponent: FC<FeeTypesComponentProps> = ({ feeTypes, handleFeeTypeChange, handleFeeCheckboxChange, removeFeeType, addFeeType, handleFormFieldsChange, currency }) => {
  const {isOpen, openModal, closeModal} = useModal();

  return (
    <div className="mb-6">
      <h3 className="text-xl font-bold mb-4 flex items-center gap-2">
        Typy poplatků
        <CiEdit
          onClick={openModal}
          className="text-2xl cursor-pointer text-gray-600 hover:text-gray-800"
        />
      </h3>
      {feeTypes.map((feeType, index) => (
        <div key={index} className="flex justify-between mb-4 bg-gray-100 p-3 rounded-lg">
          <div>

            <p className="flex items-center gap-2">
              Název poplatku: {feeType.name}
            </p>
            <p>Částka: {feeType.amount} {currency}</p>
            {feeType.requiresMembershipCardNumber && <p>Vyžaduje členskou kartu</p>}
            {feeType.allowsAdvancedInformation && <p>Povolit pokročilé informace</p>}
            <p>
              Formulářová pole:{" "}
              <span title={feeType.visibleFormFields.map((item) => translate(item)).join(", ")}>
                    {feeType.visibleFormFields.length === 0
                      ? translate("Žádná")
                      : feeType.visibleFormFields
                        .slice(0, 3)
                        .map((item) => translate(item))
                        .join(", ") +
                      (feeType.visibleFormFields.length > 3 ? ", ..." : "")}
                  </span>
            </p>
          </div>
          <MdOutlineDelete
            onClick={() => removeFeeType(index)}
            className="text-red-500 rounded-md size-6 cursor-pointer"
          />
        </div>
      ))}
      <FeeTypesComponentModal
        open={isOpen}
        onClose={closeModal}
        addFeeType={addFeeType}
        feeTypes={feeTypes}
        handleFeeTypeChange={handleFeeTypeChange}
        handleFeeCheckboxChange={handleFeeCheckboxChange}
        removeFeeType={removeFeeType}
        handleFormFieldsChange={handleFormFieldsChange}
      />
    </div>
  );
};

export default FeeTypesComponent;
